export const GET_FOREIGN_TRAVEL_REQUEST = "GET_FOREIGN_TRAVEL_REQUEST";
export const GET_FOREIGN_TRAVEL_SUCCESS = "GET_FOREIGN_TRAVEL_SUCCESS";
export const GET_FOREIGN_TRAVEL_FAIL = "GET_FOREIGN_TRAVEL_FAIL";

export const UPDATE_FOREIGN_TRAVEL_STATUS = "UPDATE_FOREIGN_TRAVEL_STATUS";
